"use client"

import { Image } from "@/app/components/image"
import { UpdateHighlighter } from "@/app/components/update-highlighter"
import {
  formatPrice,
  getPriceFormatter,
  maximum2FractionDigitsFormatter,
} from "@/app/price/utils"
import type { Currency } from "@anaconda/core/price/types"
import { cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  currency: Currency
  className?: string
}

const getCurrencyFormatter = (value: number) => {
  if (value < 1) return maximum2FractionDigitsFormatter
  return getPriceFormatter(value)
}

export function CurrencyPrice({ currency, className }: Props) {
  const { usdExchangeRate: price } = currency

  if (!price) return null
  const safePrice = Number(price)

  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      {currency.icon && (
        <div className="relative aspect-square h-[13px]">
          <Image imageSrc={currency.icon} alt={currency.abbreviation} />
        </div>
      )}
      <span className="uppercase">
        <UpdateHighlighter
          value={safePrice}
          displayValue={`$${formatPrice(safePrice, getCurrencyFormatter(safePrice))}`}
        />
      </span>
    </div>
  )
}
